export default __webpack_public_path__ + "static/media/mebloscianki4.65afbbf7.jpg";